import { Component } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-status-overzicht-filter',
  templateUrl: './status-overzicht-filter.component.html',
  styleUrls: ['./status-overzicht-filter.component.less']
})
export class StatusOverzichtFilterComponent {


  constructor(private relatieService:RelatiesService) {

  }
 
  KlantAfkortingInp: string = "";
  startInp :Date ;
  endInp :Date ;

  KlantAfkorting: string = "";
  start :Date ;
  end :Date ;

  doFilter() {
    this.KlantAfkorting = this.KlantAfkortingInp;
    this.start = this.startInp;
    this.end = this.endInp;
  }

  relatieChange(event:any) {
    this.relatieService.getRelatie(event).subscribe(data => {
      this.KlantAfkortingInp = data.Afkorting;
    })
  }


}
